import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import './AddModal.css';

const EditCategoryModal = ({ handleClose, show, modalInfo, onEdit }) => {
    const [categoryID, setCategoryID] = useState('');
    const [categoryName, setCategoryName] = useState('');
    const [categoryDesc, setCategoryDesc] = useState('');
    const [modifiedBy, setModifiedBy] = useState('');

    useEffect(() => {
        setCategoryID(modalInfo.categoryID);
        setModifiedBy(localStorage.getItem('badgeID'));
        setCategoryName(modalInfo.categoryName);
        setCategoryDesc(modalInfo.categoryDesc);
    }, [modalInfo.categoryID, modalInfo.categoryName, modalInfo.categoryDesc]);

    const onSubmit = (e) => {
        e.preventDefault();

        if (!categoryName) {
            alert('Please enter a folder name');
        } else if (!categoryDesc) {
            alert('Please enter your folder description');
        } else {
            onEdit({
                categoryID,
                categoryName,
                categoryDesc,
                modifiedBy,
            });

            setCategoryName('');
            setCategoryDesc('');
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    Edit Folder
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit}>
                    <Form.Group className='mb-3'>
                        <Form.Label>Folder Name</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder='Insert your folder name here...'
                            style={{ width: '100%' }}
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Folder Description</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder='Insert your folder description here...'
                            style={{ width: '100%' }}
                            value={categoryDesc}
                            onChange={(e) => setCategoryDesc(e.target.value)}
                        />
                    </Form.Group>
                    <Button as='input' type='submit' value='Submit' />
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditCategoryModal;
